import { FormGroup, FormLabel, TextField } from '@mui/material';
import useStylesEventExtra from 'app/event/styles/useStylesEventExtra.styles';
import CustomTextValidator from 'common/components/CustomTextValidators';
import useStylesForm from 'common/components/styles/useStylesForm.styles';
import AssetType from 'common/enums/assetTypes';
import LayoutSubForm from 'common/layouts/LayoutSubForm';
import { useFormFields } from 'libs/hooksLib';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { ValidatorForm } from 'react-material-ui-form-validator';

const DiscountForm = (props) => {
    const { discount, onSubmit, onClose, index } = props;
    const { t } = useTranslation();
    const { classes: classes1 } = useStylesEventExtra();
    const { classes: classes2, cx } = useStylesForm();
    const classes = { ...classes1, ...classes2 };

    const { enqueueSnackbar } = useSnackbar();

    const [fields, handleFieldChange] = useFormFields({
        name: discount.name,
        discountCode: discount.discountCode,
        description: discount.description,
        duration: discount.duration / 60,
        percent: discount.percent,
        type: AssetType.DISCOUNT,
        discountType: discount.discountType,
    });

    const handleSaveDiscount = (event) => {
        event.preventDefault();
        onSubmit({
            ...fields,
            duration: fields.duration * 60,
            discountType: 'percent',
            ...(fields.discountCode && fields.discountCode !== '' ? { discountType: 'promocode' } : {}),
        });
        // onClose();
    };

    function handleError(event) {
        enqueueSnackbar(t('event.eventExtraDiscounts.discountForm.formError'), {
            variant: 'error',
        });
    }

    return (
        <ValidatorForm onSubmit={handleSaveDiscount} onError={handleError} style={{ height: '100%' }}>
            <LayoutSubForm
                key={index}
                sectionName={t('discount')}
                close={onClose}
                done={() => {}}
                showCloseButton={true}
            >
                <FormGroup>
                    <FormLabel>{t('event.eventExtraDiscounts.discountForm.name')}</FormLabel>
                    <CustomTextValidator
                        name="name"
                        fullWidth={true}
                        variant="outlined"
                        size="small"
                        value={fields.name}
                        onChange={handleFieldChange}
                        validators={['required']}
                        errorMessages={[t('app.common.required')]}
                        useRegExpText={false}
                    />
                </FormGroup>

                <FormGroup>
                    <FormLabel>{t('event.eventExtraDiscounts.discountForm.promoCode')}</FormLabel>
                    <CustomTextValidator
                        name="discountCode"
                        fullWidth={true}
                        variant="outlined"
                        size="small"
                        value={fields.discountCode}
                        onChange={handleFieldChange}
                        validators={['required']}
                        errorMessages={[t('app.common.required')]}
                        useRegExpText={false}
                    />
                </FormGroup>

                <div className={classes.dFlex}>
                    <FormGroup className={cx(classes.w100pct, classes.mr2)}>
                        <FormLabel>{t('event.eventExtraDiscounts.discountForm.durationInMinutes')}</FormLabel>
                        <CustomTextValidator
                            name="duration"
                            fullWidth={true}
                            variant="outlined"
                            size="small"
                            value={fields.duration}
                            onChange={handleFieldChange}
                            validators={['required']}
                            type={'number'}
                            errorMessages={[t('app.common.required')]}
                        />
                    </FormGroup>

                    <FormGroup className={classes.w100pct}>
                        <FormLabel>{t('event.eventExtraDiscounts.discountForm.percent')}</FormLabel>
                        <CustomTextValidator
                            name="percent"
                            fullWidth={true}
                            variant="outlined"
                            size="small"
                            value={fields.percent}
                            onChange={handleFieldChange}
                            validators={['required']}
                            type={'number'}
                            errorMessages={[t('app.common.required')]}
                        />
                    </FormGroup>
                </div>

                <FormGroup>
                    <FormLabel>{t('event.eventExtraDiscounts.discountForm.description')}</FormLabel>
                    <TextField
                        name="description"
                        fullWidth={true}
                        className={classes.textField}
                        multiline
                        rows={4}
                        variant="outlined"
                        size="small"
                        value={fields.description}
                        onChange={handleFieldChange}
                    />
                </FormGroup>
            </LayoutSubForm>
        </ValidatorForm>
    );
};

export default DiscountForm;